import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <Fragment>
      <section
        className="page-banner-sec text-center"
        style={{
          backgroundImage: `url("../assets/frontend/img/about-banner.jpg")`,
        }}
      >
        <div className="container">
          <ul className="clearfix paginations-cust">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>Privacy Policy</li>
          </ul>
          <h1>Privacy Policy</h1>
        </div>
      </section>

      <section className="cms-content-sec">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div style={{ padding: "30px 0" }}>
                <p>
                  <strong>Effective Date:</strong> 12/12/2025
                </p>

                <p>
                  At One Time Success, we are committed to protecting your
                  privacy. This Privacy Policy explains how we collect, use,
                  disclose, and safeguard your information when you use our
                  educational app. By using our app, you consent to the data
                  practices described in this policy.
                </p>

                <h3>1. Information We Collect</h3>
                <p>We may collect the following types of information:</p>
                <ul>
                  <li>
                    <strong>Personal Information:</strong> This includes
                    identifiable information such as your name, email address,
                    and profile details that you provide when creating an
                    account.
                  </li>
                  <li>
                    <strong>Usage Data:</strong> We may collect information on
                    how you access and use the app, including device information,
                    IP address, browser type, and geographical location.
                  </li>
                  <li>
                    <strong>Content Data:</strong> Any content you create or
                    upload within the app, such as assignments, notes, and test
                    results.
                  </li>
                </ul>

                <h3>2. How We Use Your Information</h3>
                <p>
                  We use the information we collect for various purposes,
                  including:
                </p>
                <ul>
                  <li>To provide and maintain our services.</li>
                  <li>To notify you about changes to our app.</li>
                  <li>
                    To allow you to participate in interactive features when you
                    choose to do so.
                  </li>
                  <li>To provide customer support.</li>
                  <li>
                    To gather analysis or valuable information so that we can
                    improve the app.
                  </li>
                  <li>To monitor the usage of the app.</li>
                  <li>
                    To detect, prevent, and address technical issues.
                  </li>
                  <li>
                    To send you newsletters and promotional content (with your
                    consent).
                  </li>
                </ul>

                <h3>3. Data Sharing and Disclosure</h3>
                <p>
                  We do not sell, trade, or otherwise transfer your personal
                  information to third parties without your consent, except for:
                </p>
                <ul>
                  <li>
                    <strong>Service Providers:</strong> We may employ third-party
                    companies to facilitate our app, provide the service, or
                    assist us in analyzing how our app is used.
                  </li>
                  <li>
                    <strong>Legal Requirements:</strong> We may disclose your
                    personal information if required to do so by law or in
                    response to valid requests by public authorities.
                  </li>
                </ul>

                <h3>4. Data Security</h3>
                <p>
                  We take reasonable measures to help protect information about
                  you from loss, theft, misuse, and unauthorized access,
                  disclosure, alteration, and destruction. However, no method of
                  transmission over the Internet or method of electronic storage
                  is 100% secure.
                </p>

                <h3>5. Children's Privacy</h3>
                <p>
                  Our app is not intended for use by children under the age of
                  13. We do not knowingly collect personally identifiable
                  information from children under 13. If you are a parent or
                  guardian and you are aware that your child has provided us with
                  personal information, please contact us.
                </p>

                <h3>6. Your Rights</h3>
                <p>
                  Depending on your location, you may have the following rights
                  regarding your personal information:
                </p>
                <ul>
                  <li>
                    <strong>The right to access</strong> – You have the right to
                    request copies of your personal data.
                  </li>
                  <li>
                    <strong>The right to rectification</strong> – You have the
                    right to request that we correct any information you believe
                    is inaccurate.
                  </li>
                  <li>
                    <strong>The right to erasure</strong> – You have the right to
                    request that we erase your personal data, under certain
                    conditions.
                  </li>
                  <li>
                    <strong>The right to restrict processing</strong> – You have
                    the right to request that we restrict the processing of your
                    personal data, under certain conditions.
                  </li>
                  <li>
                    <strong>The right to data portability</strong> – You have the
                    right to request that we transfer the data that we have
                    collected to another organization, or directly to you, under
                    certain conditions.
                  </li>
                </ul>

                <h3>7. Changes to This Privacy Policy</h3>
                <p>
                  We may update our Privacy Policy from time to time. We will
                  notify you of any changes by posting the new Privacy Policy on
                  this page. You are advised to review this Privacy Policy
                  periodically for any changes.
                </p>

                <h3>8. Contact Us</h3>
                <p>
                  If you have any questions about this Privacy Policy, please
                  contact us by email:{" "}
                  <a href="mailto:info@onetimesuccess.com">
                    info@onetimesuccess.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default PrivacyPolicy;
